// 'use client';

// import React, { useState } from 'react';
// import Icon from '@/components/ui/AppIcon';

// interface QuickFormData {
//   name: string;
//   email: string;
//   subject: string;
//   message: string;
// }

// const QuickContactForm: React.FC = () => {
//   const [formData, setFormData] = useState<QuickFormData>({
//     name: '',
//     email: '',
//     subject: '',
//     message: ''
//   });
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const handleInputChange = (field: keyof QuickFormData, value: string) => {
//     setFormData(prev => ({ ...prev, [field]: value }));
//   };

//   const handleSubmit = (e: React.FormEvent) => {
//     e.preventDefault();
//     setIsSubmitted(true);

//     setTimeout(() => {
//       setIsSubmitted(false);
//       setFormData({
//         name: '',
//         email: '',
//         subject: '',
//         message: ''
//       });
//     }, 3000);
//   };

//   const subjectOptions = [
//     'General Inquiry',
//     'Project Quote Request',
//     'Technical Support',
//     'Partnership Opportunity',
//     'Career Inquiry',
//     'Other'
//   ];

//   return (
//     <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-10 border border-border">
//       <div className="flex items-center space-x-3 mb-6">
//         <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
//           <Icon name="ChatBubbleLeftRightIcon" size={24} className="text-primary" />
//         </div>
//         <div>
//           <h2 className="text-2xl lg:text-3xl font-bold text-text-primary">
//             Quick Contact Form
//           </h2>
//           <p className="text-sm text-text-secondary">We&apos;ll respond within 24 hours</p>
//         </div>
//       </div>

//       {isSubmitted ? (
//         <div className="py-12 text-center">
//           <div className="flex items-center justify-center w-16 h-16 rounded-full bg-success/10 mx-auto mb-4">
//             <Icon name="CheckCircleIcon" size={40} className="text-success" />
//           </div>
//           <h3 className="text-xl font-bold text-text-primary mb-2">
//             Message Sent Successfully!
//           </h3>
//           <p className="text-text-secondary">
//             Thank you for contacting us. We&apos;ll get back to you soon.
//           </p>
//         </div>
//       ) : (
//         <form onSubmit={handleSubmit} className="space-y-6">
//           <div>
//             <label htmlFor="quick-name" className="block text-sm font-semibold text-text-primary mb-2">
//               Your Name *
//             </label>
//             <input
//               type="text"
//               id="quick-name"
//               value={formData.name}
//               onChange={(e) => handleInputChange('name', e.target.value)}
//               className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-text-primary"
//               placeholder="John Doe"
//               required
//             />
//           </div>

//           <div>
//             <label htmlFor="quick-email" className="block text-sm font-semibold text-text-primary mb-2">
//               Email Address *
//             </label>
//             <input
//               type="email"
//               id="quick-email"
//               value={formData.email}
//               onChange={(e) => handleInputChange('email', e.target.value)}
//               className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-text-primary"
//               placeholder="john@example.com"
//               required
//             />
//           </div>

//           {/* <div>
//             <label htmlFor="quick-subject" className="block text-sm font-semibold text-text-primary mb-2">
//               Subject *
//             </label>
//             <select
//               id="quick-subject"
//               value={formData.subject}
//               onChange={(e) => handleInputChange('subject', e.target.value)}
//               className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-text-primary bg-white"
//               required
//             >
//               <option value="">Select a subject</option>
//               {subjectOptions.map((option) => (
//                 <option key={option} value={option}>
//                   {option}
//                 </option>
//               ))}
//             </select>
//           </div> */}

//           <div>
//             <label htmlFor="quick-message" className="block text-sm font-semibold text-text-primary mb-2">
//               Message *
//             </label>
//             <textarea
//               id="quick-message"
//               value={formData.message}
//               onChange={(e) => handleInputChange('message', e.target.value)}
//               rows={6}
//               className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-text-primary resize-none"
//               placeholder="Tell us about your project or inquiry..."
//               required
//             />
//           </div>

//           <button
//             type="submit"
//             className="w-full flex items-center justify-center space-x-2 px-6 py-4 bg-primary text-white rounded-lg font-semibold hover:bg-brand-primary hover:shadow-lg hover:-translate-y-0.5 transition-all duration-base"
//           >
//             <span>Send Message</span>
//             <Icon name="PaperAirplaneIcon" size={20} />
//           </button>

//           <p className="text-xs text-text-secondary text-center">
//             By submitting this form, you agree to our Privacy Policy and Terms of Service.
//           </p>
//         </form>
//       )}
//     </div>
//   );
// };

// export default QuickContactForm;




'use client';

import React, { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import toast from 'react-hot-toast';

interface QuickFormData {
  name: string;
  email: string;
  subject: string;
  message: string;
}

const QuickContactForm: React.FC = () => {
  const [formData, setFormData] = useState<QuickFormData>({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleInputChange = (field: keyof QuickFormData, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();

  //   const toastId = toast.loading("Sending your message...");

  //   setIsLoading(true);
  //   setErrorMessage(null);

  //   try {
  //     const response = await fetch('http://localhost/vidhmsolution_backend/contact.php', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json'
  //       },
  //       body: JSON.stringify({
  //         name: formData.name,
  //         email: formData.email,
  //         message: formData.message,
  //         // you can send subject as well if your backend supports it
  //         subject: formData.subject,
  //       })
  //     });

  //     const result = await response.json();

  //      toast.dismiss(toastId);

  //     if (response.ok && result.status === 'success') {

  //       toast.success("🎉 Message sent successfully! We'll reply soon.");

  //       setIsSubmitted(true);
  //       setFormData({
  //         name: '',
  //         email: '',
  //         subject: '',
  //         message: ''
  //       });
  //     } else {
  //       toast.error(result.message || "Something went wrong.");
  //       setErrorMessage(result.message || 'Something went wrong. Please try again.');
  //     }
  //   } catch (error) {
  //     setErrorMessage('Network error: Unable to send message.');
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const toastId = toast.loading("Sending your message...");

    setIsLoading(true);
    setErrorMessage(null);

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      toast.dismiss(toastId);

      if (response.ok && result.success) {
        toast.success("🎉 Message sent successfully! We'll reply soon.");

        setIsSubmitted(true);
        setFormData({
          name: '',
          email: '',
          subject: '',
          message: ''
        });
      } else {
        toast.error(result.message || "Something went wrong.");
        setErrorMessage(result.message || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.log(error);
      toast.dismiss(toastId);
      toast.error("Network error. Try again.");
      setErrorMessage('Network error: Unable to send message.');
    } finally {
      setIsLoading(false);
    }
  };


  if (isSubmitted) {
    return (
      <div data-component-id="src/app/contact/components/QuickContactForm.tsx:290:6" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="290" data-component-file="QuickContactForm.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-white%20rounded-2xl%20shadow-lg%20p-8%20lg%3Ap-10%20border%20border-border%20text-center%22%7D" className="bg-white rounded-2xl shadow-lg p-8 lg:p-10 border border-border text-center">
        <div data-component-id="src/app/contact/components/QuickContactForm.tsx:291:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="291" data-component-file="QuickContactForm.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20w-16%20h-16%20rounded-full%20bg-success%2F10%20mx-auto%20mb-4%22%7D" className="flex items-center justify-center w-16 h-16 rounded-full bg-success/10 mx-auto mb-4">
          <Icon data-component-id="src/app/contact/components/QuickContactForm.tsx:292:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="292" data-component-file="QuickContactForm.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22CheckCircleIcon%22%2C%22className%22%3A%22text-success%22%7D" name="CheckCircleIcon" size={40} className="text-success" />
        </div>
        <h3 data-component-id="src/app/contact/components/QuickContactForm.tsx:294:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="294" data-component-file="QuickContactForm.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-xl%20font-bold%20text-text-primary%20mb-2%22%2C%22textContent%22%3A%22Message%20Sent%20Successfully!%22%7D" className="text-xl font-bold text-text-primary mb-2">
          Message Sent Successfully!
        </h3>
        <p data-component-id="src/app/contact/components/QuickContactForm.tsx:297:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="297" data-component-file="QuickContactForm.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-text-secondary%22%2C%22textContent%22%3A%22Thank%20you%20for%20contacting%20us.%20We'll%20get%20back%20to%20you%20soon.%22%7D" className="text-text-secondary">
          Thank you for contacting us. We&apos;ll get back to you soon.
        </p>
        <button data-component-id="src/app/contact/components/QuickContactForm.tsx:300:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="300" data-component-file="QuickContactForm.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22mt-6%20px-6%20py-2%20bg-primary%20text-white%20rounded-lg%20hover%3Abg-brand-primary%22%2C%22textContent%22%3A%22Send%20Another%20Message%22%7D"
          onClick={() => setIsSubmitted(false)}
          className="mt-6 px-6 py-2 bg-primary text-white rounded-lg hover:bg-brand-primary"
        >
          Send Another Message
        </button>
      </div>
    );
  }

  return (
    <div data-component-id="src/app/contact/components/QuickContactForm.tsx:311:4" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="311" data-component-file="QuickContactForm.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-white%20rounded-2xl%20shadow-lg%20p-8%20lg%3Ap-10%20border%20border-border%22%7D" className="bg-white rounded-2xl shadow-lg p-8 lg:p-10 border border-border">
      <div data-component-id="src/app/contact/components/QuickContactForm.tsx:312:6" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="312" data-component-file="QuickContactForm.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20space-x-3%20mb-6%22%7D" className="flex items-center space-x-3 mb-6">
        <div data-component-id="src/app/contact/components/QuickContactForm.tsx:313:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="313" data-component-file="QuickContactForm.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20w-12%20h-12%20rounded-lg%20bg-primary%2F10%22%7D" className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary/10">
          <Icon data-component-id="src/app/contact/components/QuickContactForm.tsx:314:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="314" data-component-file="QuickContactForm.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChatBubbleLeftRightIcon%22%2C%22className%22%3A%22text-primary%22%7D" name="ChatBubbleLeftRightIcon" size={24} className="text-primary" />
        </div>
        <div data-component-id="src/app/contact/components/QuickContactForm.tsx:316:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="316" data-component-file="QuickContactForm.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
          <h2 data-component-id="src/app/contact/components/QuickContactForm.tsx:317:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="317" data-component-file="QuickContactForm.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-2xl%20lg%3Atext-3xl%20font-bold%20text-text-primary%22%2C%22textContent%22%3A%22Quick%20Contact%20Form%22%7D" className="text-2xl lg:text-3xl font-bold text-text-primary">
            Quick Contact Form
          </h2>
          <p data-component-id="src/app/contact/components/QuickContactForm.tsx:320:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="320" data-component-file="QuickContactForm.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-sm%20text-text-secondary%22%2C%22textContent%22%3A%22We'll%20respond%20within%2024%20hours%22%7D" className="text-sm text-text-secondary">We&apos;ll respond within 24 hours</p>
        </div>
      </div>

      <form data-component-id="src/app/contact/components/QuickContactForm.tsx:324:6" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="324" data-component-file="QuickContactForm.tsx" data-component-name="form" data-component-content="%7B%22elementName%22%3A%22form%22%2C%22className%22%3A%22space-y-6%22%7D" onSubmit={handleSubmit} className="space-y-6" noValidate>
        <div data-component-id="src/app/contact/components/QuickContactForm.tsx:325:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="325" data-component-file="QuickContactForm.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
          <label data-component-id="src/app/contact/components/QuickContactForm.tsx:326:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="326" data-component-file="QuickContactForm.tsx" data-component-name="label" data-component-content="%7B%22elementName%22%3A%22label%22%2C%22className%22%3A%22block%20text-sm%20font-semibold%20text-text-primary%20mb-2%22%2C%22textContent%22%3A%22Your%20Name%20*%22%7D" htmlFor="quick-name" className="block text-sm font-semibold text-text-primary mb-2">
            Your Name *
          </label>
          <input data-component-id="src/app/contact/components/QuickContactForm.tsx:329:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="329" data-component-file="QuickContactForm.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22text%22%2C%22id%22%3A%22quick-name%22%2C%22className%22%3A%22w-full%20px-4%20py-3%20border%20border-input%20rounded-lg%20focus%3Aoutline-none%20focus%3Aring-2%20focus%3Aring-ring%20text-text-primary%22%7D"
            type="text"
            id="quick-name"
            value={formData.name}
            onChange={(e) => handleInputChange('name', e.target.value)}
            className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-text-primary"
            placeholder="John Doe"
            required
            disabled={isLoading}
          />
        </div>

        <div data-component-id="src/app/contact/components/QuickContactForm.tsx:341:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="341" data-component-file="QuickContactForm.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
          <label data-component-id="src/app/contact/components/QuickContactForm.tsx:342:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="342" data-component-file="QuickContactForm.tsx" data-component-name="label" data-component-content="%7B%22elementName%22%3A%22label%22%2C%22className%22%3A%22block%20text-sm%20font-semibold%20text-text-primary%20mb-2%22%2C%22textContent%22%3A%22Email%20Address%20*%22%7D" htmlFor="quick-email" className="block text-sm font-semibold text-text-primary mb-2">
            Email Address *
          </label>
          <input data-component-id="src/app/contact/components/QuickContactForm.tsx:345:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="345" data-component-file="QuickContactForm.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22email%22%2C%22id%22%3A%22quick-email%22%2C%22className%22%3A%22w-full%20px-4%20py-3%20border%20border-input%20rounded-lg%20focus%3Aoutline-none%20focus%3Aring-2%20focus%3Aring-ring%20text-text-primary%22%7D"
            type="email"
            id="quick-email"
            value={formData.email}
            onChange={(e) => handleInputChange('email', e.target.value)}
            className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-text-primary"
            placeholder="john@example.com"
            required
            disabled={isLoading}
          />
        </div>

        {/* Uncomment if you want to enable subject
        <div>
          <label htmlFor="quick-subject" className="block text-sm font-semibold text-text-primary mb-2">
            Subject *
          </label>
          <select
            id="quick-subject"
            value={formData.subject}
            onChange={(e) => handleInputChange('subject', e.target.value)}
            className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-text-primary bg-white"
            required
            disabled={isLoading}
          >
            <option value="">Select a subject</option>
            {subjectOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        */}

        <div data-component-id="src/app/contact/components/QuickContactForm.tsx:380:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="380" data-component-file="QuickContactForm.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
          <label data-component-id="src/app/contact/components/QuickContactForm.tsx:381:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="381" data-component-file="QuickContactForm.tsx" data-component-name="label" data-component-content="%7B%22elementName%22%3A%22label%22%2C%22className%22%3A%22block%20text-sm%20font-semibold%20text-text-primary%20mb-2%22%2C%22textContent%22%3A%22Message%20*%22%7D" htmlFor="quick-message" className="block text-sm font-semibold text-text-primary mb-2">
            Message *
          </label>
          <textarea data-component-id="src/app/contact/components/QuickContactForm.tsx:384:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="384" data-component-file="QuickContactForm.tsx" data-component-name="textarea" data-component-content="%7B%22elementName%22%3A%22textarea%22%2C%22id%22%3A%22quick-message%22%2C%22className%22%3A%22w-full%20px-4%20py-3%20border%20border-input%20rounded-lg%20focus%3Aoutline-none%20focus%3Aring-2%20focus%3Aring-ring%20text-text-primary%20resize-none%22%7D"
            id="quick-message"
            value={formData.message}
            onChange={(e) => handleInputChange('message', e.target.value)}
            rows={6}
            className="w-full px-4 py-3 border border-input rounded-lg focus:outline-none focus:ring-2 focus:ring-ring text-text-primary resize-none"
            placeholder="Tell us about your project or inquiry..."
            required
            disabled={isLoading}
          />
        </div>

        {errorMessage && (
          <p data-component-id="src/app/contact/components/QuickContactForm.tsx:397:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="397" data-component-file="QuickContactForm.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-red-600%20text-sm%22%7D" className="text-red-600 text-sm">{errorMessage}</p>
        )}

        <button data-component-id="src/app/contact/components/QuickContactForm.tsx:400:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="400" data-component-file="QuickContactForm.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22submit%22%7D"
          type="submit"
          disabled={isLoading}
          className={`w-full flex items-center justify-center space-x-2 px-6 py-4 rounded-lg font-semibold transition-all duration-base
            ${isLoading ? 'bg-gray-400 cursor-not-allowed' : 'bg-primary text-white hover:bg-brand-primary hover:shadow-lg hover:-translate-y-0.5'}`}
        >
          <span data-component-id="src/app/contact/components/QuickContactForm.tsx:406:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="406" data-component-file="QuickContactForm.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D">{isLoading ? 'Sending...' : 'Send Message'}</span>
          <Icon data-component-id="src/app/contact/components/QuickContactForm.tsx:407:10" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="407" data-component-file="QuickContactForm.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22PaperAirplaneIcon%22%7D" name="PaperAirplaneIcon" size={20} />
        </button>

        <p data-component-id="src/app/contact/components/QuickContactForm.tsx:410:8" data-component-path="src/app/contact/components/QuickContactForm.tsx" data-component-line="410" data-component-file="QuickContactForm.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20text-text-secondary%20text-center%22%2C%22textContent%22%3A%22By%20submitting%20this%20form%2C%20you%20agree%20to%20our%20Privacy%20Policy%20and%20Terms%20of%20Service.%22%7D" className="text-xs text-text-secondary text-center">
          By submitting this form, you agree to our Privacy Policy and Terms of Service.
        </p>
      </form>
    </div>
  );
};

export default QuickContactForm;
